import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum'
import { createRandomId } from 'src/utils/createRandomId'

let inMemoryId: string | undefined

export const getAnonymousId = (): string | undefined => {
  try {
    const existing = localStorage.getItem(LocalStorageKey.ANONYMOUS_ID)

    if (existing) {
      return existing
    }

    const created = createRandomId()
    localStorage.setItem(LocalStorageKey.ANONYMOUS_ID, created)

    return created
  } catch (error) {
    if (!inMemoryId) {
      inMemoryId = createRandomId()
    }

    return inMemoryId
  }
}
